/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.EftWithdrawResponse,
  EftWithdraw: (params: vp.EftWithdrawRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostEftWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldEftWithdraw, setShouldEftWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.EftWithdrawRequest>({
    Amount: 0,
    PortalUser: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    DOB: '',
    PhoneNumber: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    ClientAccountID: '',
    Country: '',
    TransactionLabel: '',
    PostalCode: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    IBAN: '',
    SortCode: '',
    Currency: '',
    Token: '',
    ClientReferenceNumber: '',
    Notes: '',
    FlinksAccountID: '',
    FlinksLoginID: '',
    KYCPerformed: false,
    DelayBankingInfo: false,
    ParentTransactionID: '',
    KYCReferenceNumber: '',
  });
  const [response, setResponse] = useState<vp.EftWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    TransactionID: '',
    Flagged: '',
  });

  useEffect(() => {
    if (!shouldEftWithdraw) return () => {};

    const PostEftWithdraw = async () => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');
      const res = await api.postEftWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldEftWithdraw) void PostEftWithdraw();
    setShouldEftWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldEftWithdraw]);

  return [
    response,
    (_params: vp.EftWithdrawRequest) => {
      setParams(_params);
      setShouldEftWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        TransactionID: '',
        Flagged: '',
      });
      setShouldEftWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostEftWithdraw);